import request from 'utils/request'
// 获取表格信息
export const getTableData = data => request().post('sovereign/rate/page', data)
// 添加或者修改
export const add = data => request().post('sovereign/rate/saveOrUpdate', data)
// 删除
export const remove = id => request().get(`sovereign/rate/delete/${id}`)

export const Upload = data =>
  request().post('sovereign/rate/file/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 下载模板
export const templateDownload = () =>
  request().get(`sovereign/rate/template/download`, {
    responseType: 'blob',
  })
